import type { NextPage } from "next";
import dynamic from "next/dynamic";

import NextSectionAction from "components/next-section-action";

import Page from "../../components/layout/page";
import AutomaticSigningPackets from "../../components/views/docflo/automatic-signing-packets";
import DetailsGrid from "../../components/views/docflo/details-grid";
import MainHero from "../../components/views/docflo/main-hero";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const Docflo: NextPage = () => (
  <Page
    title="Enerflo Solar Software Platform Features | Docflo Doc Signing"
    description="Replace time-consuming, manual doc signing processes and limit change orders with Docflo, the intelligent doc signing solution purpose-built for solar."
  >
    <MainHero />
    <AutomaticSigningPackets />
    <DetailsGrid />
    <NextSectionAction
      buttonText="View Integrated Solar Financing"
      url="/features/lendflo"
      description="Get customers financed fast"
    />
    <DemoFormSection />
  </Page>
);

export default Docflo;
